import React from 'react';
import style from './Footer.module.css';
import NewsLetter from '../NewsLetter/NewsLetter';
import Social from './Social/Social';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className={style.SectionColor}>
      <div className={style.Footer}>
        <div className={style.Logo}>
          <div>HackerBro</div>
        </div>
        <div className={style.Section}>
          <ul>
            <Link to='/explore'>
              <li style={{ color: 'white' }}>Explore</li>
            </Link>
            <li>Hackers</li>
            <li>Projects</li>
          </ul>
        </div>
        <div className={style.Section}>
          <ul>
            <li>About</li>
            <li>Rules</li>
            <Link to='/career'>
              <li style={{ color: 'white' }}>Career</li>
            </Link>
          </ul>
        </div>
        <div className={style.Section}>
          <ul>
            <li>Blog</li>
            <Link to='/contact'>
              <li style={{ color: 'white' }}>Contact</li>
            </Link>
            <li>Help</li>
          </ul>
        </div>
      </div>
      <NewsLetter />
      <Social />
    </div>
  );
};

export default Footer;
